module.exports = __webpack_public_path__ + "static/media/moneyfold.aa2ad790.svg";